export const constants = {
  TOUCHSTART: 'touchstart',
  TOUCHMOVE: 'touchmove',
  TOUCHEND: 'touchend',
};

export default class UserTouchController {

  constructor(element, {
    touchstartCallback,
    touchmoveCallback,
    touchendCallback,
    tolerance = 5,
  }) {
    this.element = element;
    this.touchstart = touchstartCallback;
    this.touchmove = touchmoveCallback;
    this.touchend = touchendCallback;
    this.tolerance = tolerance;
  }

  trackTouchPosition(event, type) {
    this[`xCoordinate${type}`] = event.touches[0].pageX;
    this[`yCoordinate${type}`] = event.touches[0].pageY;
  }

  /* istanbul ignore next */
  trackTouchDirection() {
    this.xDirection = this.calculateXDirection();
    this.yDirection = this.calculateYDirection();
    this.isStationary = this.calculateIsStationary();
  }

  calculateXDirection() {
    let direction;

    if (this.xCoordinateStart <= this.xCoordinateLatest) {
      direction = 'right';
    } else {
      direction = 'left';
    }

    return direction;
  }

  calculateYDirection() {
    let direction;

    if (this.yCoordinateStart <= this.yCoordinateLatest) {
      direction = 'down';
    } else {
      direction = 'up';
    }

    return direction;
  }

  calculateIsStationary() {
    let isStationary;

    if (
      Math.abs(this.xCoordinateStart - this.xCoordinateLatest) <= this.tolerance &&
      Math.abs(this.yCoordinateStart - this.yCoordinateLatest) <= this.tolerance
    ) {
      isStationary = true;
    } else {
      isStationary = false;
    }

    return isStationary;
  }

  onTouchStart(event) {
    this.trackTouchPosition(event, 'Start');
    this.trackTouchPosition(event, 'Latest');

    if (this.touchstart) {
      this.touchstart(event);
    }
  }

  onTouchMove(event) {
    this.trackTouchPosition(event, 'Latest');

    if (this.touchmove) {
      this.touchmove(event);
    }
  }

  onTouchEnd(event) {
    this.trackTouchDirection();

    if (this.touchend) {
      this.touchend(event);
    }
  }

  addEventListeners() {
    this.element.addEventListener(constants.TOUCHSTART, this.onTouchStart.bind(this));
    this.element.addEventListener(constants.TOUCHMOVE, this.onTouchMove.bind(this));
    this.element.addEventListener(constants.TOUCHEND, this.onTouchEnd.bind(this));
  }

  removeEventListeners() {
    /* istanbul ignore next */
    this.element.removeEventListener(constants.TOUCHSTART, this.onTouchStart.bind(this));
    this.element.removeEventListener(constants.TOUCHMOVE, this.onTouchMove.bind(this));
    this.element.removeEventListener(constants.TOUCHEND, this.onTouchEnd.bind(this));
  }

  destroy() {
    this.removeEventListeners();
  }

  init() {
    this.addEventListeners();
  }
}



/** WEBPACK FOOTER **
 ** ./src/utils/touchEvents.js
 **/